import { render } from "./DrawPointsTable.vue?vue&type=template&id=65e46fcc&scoped=true"
import script from "./DrawPointsTable.vue?vue&type=script&lang=js"
export * from "./DrawPointsTable.vue?vue&type=script&lang=js"

import "./DrawPointsTable.vue?vue&type=style&index=0&id=65e46fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e46fcc"],['__file',"DrawPointsTable.vue"]])

export default __exports__